/** Display-format a phone string as (XXX) XXX-XXXX. Pass-through if not 10 digits. */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';
  const digits = stripPhone(phone);
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

/** Progressive input mask: keystrokes → (XXX) XXX-XXXX. */
export function formatPhoneInput(raw: string): string {
  const digits = stripPhone(raw).slice(0, 10);
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Strip any formatted phone to its 10 digits (removes +1 country prefix). */
export function stripPhone(phone: string): string {
  let digits = phone.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  return digits;
}

/** NANP check: exactly 10 digits and area code does not start with 0 or 1. */
export function isValidNanpPhone(value: string): boolean {
  const digits = stripPhone(value);
  return digits.length === 10 && digits[0] !== '0' && digits[0] !== '1';
}
